<template>
  <div>
    <es-loader v-if="loading" style="margin: 1rem" />
    <es-exception v-if="!hasModule('PRSID:DWNLD:DOWNLOAD')"
    exceptionMessage="Sorry, you are not authorized to access this content."
  />
  <div v-else>
    <div class="document-container">
      <div class="columns">
        <div class="column">
          <div class="document" style="height:100%">
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">Download Options</div>
                </template>
              </EsHeader>
            </div>
            <div class="content">
              <es-loader v-if="this.loading === true"/>
              <div v-else>
                <es-form>
                  <template #es-form-header>
                    <div class="header-container">
                      <div class="header-elements">
                        <font-awesome-icon :icon="['fas', 'file-edit']" size="lg" />
                      </div>
                      <div class="header-elements">
                        <h6 class="title">
                          Format
                        </h6>
                      </div>
                    </div>
                  </template>
                  <template #es-form>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal ">
                        <div class="field-label is-normal">
                          <label class="label">File Format</label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <div class="text-align">
                                  {{ personIdFileFormat }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">Delimiter</label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <button v-for="(item, index) in delimiterOptions" :key="index"
                                  class="button no-radius"
                                  :class="{'selected-option': delimiter === item.option}"
                                  @click="selectType('delimiter', item.option)">
                                  {{ item.label }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">Qualifier</label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <button v-for="(item, index) in qualifierOptions" :key="index"
                                  class="button no-radius"
                                  :class="{'selected-option': qualifier === item.option}"
                                  @click="selectType('qualifier', item.option)">
                                  {{ item.label }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">Date Format</label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="select is-half-width">
                                <select class="input is-full-width"
                                  aria-label="Date Format"
                                  v-model="dateFormat"
                                >
                                  <option
                                    v-for="(item, index) in dateFormatOptions"
                                    :key="index"
                                    :value="item.option"
                                  >
                                    {{ item.label }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row removeUnderline">
                      <div class="field is-horizontal">
                        <div class="field-label is-normal">
                          <label class="label">Include Header/Footer </label>
                        </div>
                        <div class="field-body">
                          <div class="field">
                            <div class="control">
                              <div class="buttons has-addons">
                                <button v-for="(item, index) in includeHeaderFooterOptions" :key="index"
                                  class="button no-radius"
                                :class="{'selected-option': includeHeaderFooter === item.option}"
                                  @click="selectType('includeHeaderFooter', item.option)">
                                  {{ item.label }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </es-form>
              </div>
              <div class="es-actions">
                <es-form-actions>
                  <template #form-actions>
                    <div class="bottom-content">
                      <ul>
                        <li>
                          <div class="list-content" style="padding-right:5rem">
                        <button
                          class="button is-primary"
                          @click="generateExtract()">
                              Generate Extract
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </template>
                </es-form-actions>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="document" v-if="showExtract">
        <div class="header">
          <es-header>
            <template #header>
              <div class="header-title">Extract File (1)</div>
            </template>
          </es-header>
        </div>
      <div class="content table-container" >
        <es-loader v-if="loadingExtract === true"/>
          <table v-else class="table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th title="Extract Date">
                  Extract Date
                  <font-awesome-icon :icon="['fa', 'sort']"/>
                </th>
                <th title="Location Info">
                  Location Info
                  <font-awesome-icon :icon="['fa', 'sort']"/>
                </th>
                <th title="Record Count">
                  Record Count
                  <font-awesome-icon :icon="['fa', 'sort']"/>
                </th>
                <th title="Extract Name">
                  Extract Name
                  <font-awesome-icon :icon="['fa', 'sort']"/>
                </th>
                <th title="Extract Status">
                  Extract Status
                  <font-awesome-icon :icon="['fa', 'sort']"/>
                </th>
                <th title="Actions">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div  class="has-text-weight-bold">
                    {{ formatExtractDate(extract.createdDate) }}
                  </div>
                  <div>
                    <span class="padding-left--small has-text-grey">
                      {{ formatExtractTime(extract.createdDate) }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="is-flex flex-direction--column">
                    <div>
                      <router-link
                        :to="{
                        name: 'PIDistrictInfoDetails',
                        params: { code: this.districtCode },
                        }"
                        class="has-text-weight-bold has-text-primary" style="font-size:14px"
                      >
                        {{ this.districtName }}
                      </router-link>
                      <span class="has-text-grey is-italic">
                        ({{ this.districtCode }})
                      </span>
                    </div>
                    <div v-if=!this.schoolCode>
                      <span class="is-italic has-text-grey">
                        Multiple Buildings
                      </span>
                    </div>
                    <div v-else>
                      <router-link
                        :to="{
                        name: 'PISchoolInfoDetails',
                        params: {
                          districtCode: this.districtCode,
                          schoolCode: this.schoolCode,
                        },
                        }"
                        class="is-italic"
                      >
                        {{ this.schoolName }}
                      </router-link>
                      <span class="has-text-grey is-italic">
                        ({{ this.schoolCode }})
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="has-text-weight-bold">
                    {{ this.totalCount }} of {{ this.totalCount }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ extract.fileName }}
                  </div>
                </td>
                <td>
                  <div class="has-text-weight-bold">
                    {{ this.statusName }}
                  </div>
                </td>
                <td class="action">
                  <div v-if="(statusId === 3)">
                    <a v-if="extract.fileExtension" @click.prevent="downloadFile($event)"
                      :href="buildSplitUrl(extractId)">
                      Download
                    </a>
                  </div>
                  <div v-else>
                    <a @click="refreshExtract"
                      @keypress="refreshExtract"
                      role="link"
                      tabindex="0"
                    >
                      Refresh
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <iframe ref="downloadFrame" title="Download - Extract File"></iframe>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPoll,
  faFileEdit,
  faClock,
  faSyncAlt,
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader';
import FieldLabels from '@/mixins/FieldLabels';
import PermissionManager from '@/mixins/PermissionManager';
import EsFormActions from '@/components/EsFormActions.vue';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faPoll,
  faFileEdit,
  faClock,
  faSyncAlt,
  faSort,
);
export default {
  mixins: [
    FieldLabels,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsForm,
    EsHeader,
    EsFormActions,
    EsLoader,
    EsException,
    EsProfileHeader,
  },
  props: {
    active: {
      type: Boolean,
    },
    districtCode: {
      type: String,
    },
    personType: {
      type: String,
    },
    schoolCode: {
      type: String,
    },
    schoolYear: {
      type: String,
    },
    totalCount: {
      type: Number,
    },
  },

  data() {
    return this.initialData();
  },
  async created() {
    await this.onLoad();
    await this.getDistrictSchool();
  },
  computed: {
    ...mapGetters('lookups', [
      'pidExtractStatuses',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    formDataBody() {
      const formData = new FormData();
      formData.append('districtCode', this.districtCode);
      if (this.schoolCode) {
        formData.append('schoolCode', this.schoolCode);
      };
      formData.append('schoolYear', this.schoolYear);
      if (!(this.active === undefined)) {
        formData.append('active', this.active);
      };
      if (!(this.personType === undefined)) {
        formData.append('personTypeCode', this.personType);
      };
      formData.append('referrer', this.referrer);
      formData.append('delimiter', this.delimiter);
      if (this.qualifier !== null) {
        formData.append('qualifier', this.qualifier);
      };
      formData.append('dateFormat', this.dateFormat);
      formData.append('includeHeaderFooter', this.includeHeaderFooter);
      return formData;
    },
    searchParams() {
      const params = {};
      params.districtCode = this.districtCode ? this.districtCode : undefined;
      params.q = this.schoolCode ? this.schoolCode : null;

      return params;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidExtractStatuses',
    ]),
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        await Promise.all([
          this.loadPidExtractStatuses(),
        ]);
      } catch (error) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
    downloadFile(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    buildSplitUrl(dlFileId) {
      return `${axios.defaults.baseURL}personid/extracts/${dlFileId}/content`;
    },
    formatDateTime(value) {
      return moment(value).format('MM/DD/YYYY h:mmA');
    },
    formatExtractDate(value) {
      return moment(value).format('MM/DD/YYYY');
    },
    formatExtractTime(value) {
      return moment(value).format('h:mmA');
    },
    async getDistrictSchool() {
      try {
        this.loading = true;
        const response = await axios.get('schools',
          {
            params: this.searchParams,
            // paramsSerializer(params) {
            //   return qs.stringify(params, { arrayFormat: 'repeat' });
            // },
          });
        this.districts = response.data.data;
        this.districtName = this.districts[0].districtLocation.name;
        if (this.schoolCode) {
          this.schoolName = this.districts[0].location.name;
        }
      } catch (error) {
        this.showNotification('danger', ['Error getting district/school record']);
      } finally {
        this.loading = false;
      }
    },
    async getExtract() {
      try {
        this.loadingExtract = true;
        const response = await axios.get(`personid/extracts/${this.extractId}`);
        this.extract = response.data;
        this.findId = this.extract.extractStatusId;
        this.extractId = this.extract.id;
        this.getExtractStatus();
        this.showExtract = true;
      } catch (error) {
        this.showNotification('danger', ['Error getting extract record']);
      } finally {
        this.loadingExtract = false;
      }
    },
    async generateExtract() {
      try {
        this.showExtract = true;
        this.loadingExtract = true;
        this.resetNotifications();
        const response = await axios.post('personid/extracts', this.formDataBody);
        this.extract = response.data;
        this.findId = this.extract.extractStatusId;
        this.extractId = this.extract.id;
        this.getExtractStatus();
      } catch (error) {
        this.showNotification('danger', ['Error generating extract']);
      } finally {
        this.loadingExtract = false;
      }
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth"
      });
    },
    getExtractStatus() {
      this.extractStatuses = this.pidExtractStatuses;
      this.extractStatuses.forEach((id, outerIndex) => {
        if (this.extractStatuses[outerIndex].id === this.findId) {
          this.statusName = this.extractStatuses[outerIndex].name;
          this.statusId = this.extractStatuses[outerIndex].id;
        }
      });
    },
    selectType(field, option) {
      if (field === 'downloadOption') {
        this.downloadOption = option;
      }
      if (field === 'dmatchFileFormat') {
        this.dmatchFileFormat = option;
      }
      if (field === 'delimiter') {
        this.delimiter = option;
      }
      if (field === 'qualifier') {
        this.qualifier = option;
      }
      if (field === 'includeHeaderFooter') {
        this.includeHeaderFooter = option;
      }
    },
    async refreshExtract() {
      await this.getExtract();
    },
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    initialData() {
      return {
        districts: {},
        districtName: null,
        extract: [],
        extractId: null,
        extractStatuses: [],
        findId: null,
        lastDate: null,
        loading: false,
        loadingError: false,
        loadingExtract: false,
        history: [],
        schoolName: null,
        showExtract: false,
        statusId: null,
        statusName: null,
        statusObject: [],
        transactionStatuses: [],
        transactionStatusGroup: [],
        referrer: 'SEARCHBYLOC',
        personIdFileFormat: 'Version 3.0',
        personIdFileFormatOptions: ['Version 3.0', 'Version 2.1', 'Version 1.0'],
        delimiter: '09',
        delimiterOptions: [
          { label: 'Tab', option: "09" },
          { label: 'Comma', option: ',' },
        ],
        qualifier: null,
        qualifierOptions: [
          { label: 'Double Quotes ( " )', option: '"' },
          // We may need Single Quote back in the future.
          // { label: "Single Quote ( ' )", option: '\'' },
          { label: 'None', option: null },
        ],
        includeHeaderFooter: false,
        includeHeaderFooterOptions: [
          { label: 'Yes', option: true },
          { label: 'No', option: false },
        ],
        dateFormat: 'MM/dd/yyyy',
        dateFormatOptions: [
          { label: 'mm/dd/yyyy', option: 'MM/dd/yyyy' },
          { label: 'ISO Format (YYYY-MM-DD)', option: 'YYYY-MM-dd' },
          { label: 'mm/d/yyyy', option: 'MM/d/yyyy' },
          { label: 'm/d/yyyy', option: 'M/d/yyyy' },
          { label: 'm/dd/yyyy', option: 'M/dd/yyyy' },
        ],
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  .margin-bottom
    margin-bottom: 1rem
  .sort-by
    padding-right: 18px
    position: relative
    color: #777
    text-decoration: none
    &:before, &:after
    border: 4px solid transparent
    content: ""
    display: block
    height: 0
    right: 5px
    top: 50%
    position: absolute
    width: 0
    &:before
      border-bottom-color: #999
      margin-top: -9px
      &:after
        border-top-color: #999
        margin-top: 1px
  .header-container
    margin-bottom: 1rem
  .no-radius
    border-radius: 0
    background-color: #F2F2F2
    font-weight: normal
  .selected-option
    background-color: #ccc
    font-weight: bold
  .fields-container
    margin-left: 30px
  .text-align--left
    text-align: left !important
  .column-header
    padding-left: 0px
  .text-align--right
    text-align: right !important
  .text-align--left
    text-align: left !important
  .table-container
    overflow-x: auto
    white-space: nowrap
</style>
